import { itemBackgroundUrl, ucfirst } from '../../AppHelpers'
import StationAsset from './StationAsset'

export default class BrandAsset {
  constructor(obj) {
    this.id = obj.id
    this.name = obj.name
    this.href = obj.href
    this.theme = obj.theme
    this.background = itemBackgroundUrl(this.brandName) //obj.background.url;
    this.stations = []

    this.logos = {
      normal: obj.logo.url,
      square: obj.squareLogo.url,
      tv: obj.tvLogo.url,
    }

    this.nationalStation = obj.nationalStation
  }

  addStations(stationData) {
    this.safeName = stationData.safeName

    if (stationData.stations && stationData.stations.length > 0) {
      this.stations = stationData.stations.map(station => {
        return new StationAsset(station)
      })
    }
  }

  get brandName() {
    return this.href.split('/')[2]
  }

  get fullBrandName() {
    const nameParts = this.nationalStation.href.split('/')

    return `${ucfirst(nameParts[2])} ${nameParts[3].toUpperCase()}`
  }
}
